import { get } from '../base';
const endPoint = 'customers';

const getCustomerData = async (param) => {
  const response = await get(endPoint, param);
  return response;
};

export const customersAPI = {
  getCustomerData,
};
